import { MultiSelectOption, SelectedOption } from '@assetworks-llc/aw-component-lib';

/** Options for the Associated table filter. Values have no code, so they're plain labels. */
export const ASSOCIATED_FILTER_OPTIONS: MultiSelectOption[] = [{ label: 'Yes' }, { label: 'No' }];

/** The filter opens on the associated records. */
export const DEFAULT_ASSOCIATED_FILTER: SelectedOption[] = [{ label: 'Yes' }];

/**
 * Rows matching the Associated filter. Nothing selected, or both, means every row. Rows carry the
 * `associationBadge.isAssociated` flag the details tables already build. Exported for unit tests.
 */
export function filterByAssociation<T extends { associationBadge?: { isAssociated?: boolean } }>(
  rows: T[],
  selected: SelectedOption[] | null | undefined
): T[] {
  const labels = new Set((selected ?? []).map((option) => option.label));
  const showYes = labels.size === 0 || labels.has('Yes');
  const showNo = labels.size === 0 || labels.has('No');
  return rows.filter((row) => (row.associationBadge?.isAssociated ? showYes : showNo));
}

/** Options for a Status table filter. */
export const STATUS_FILTER_OPTIONS: MultiSelectOption[] = [{ label: 'Active' }, { label: 'Disabled' }];

/** Status filters open on the active records. */
export const DEFAULT_STATUS_FILTER: SelectedOption[] = [{ label: 'Active' }];

/**
 * Rows matching the Status filter. Nothing selected, or both, means every row. Rows carry the `badgeNested.enabled`
 * flag the management tables already build. Exported for unit tests.
 */
export function filterByStatus<T extends { badgeNested?: { enabled?: boolean } }>(
  rows: T[],
  selected: SelectedOption[] | null | undefined
): T[] {
  const labels = new Set((selected ?? []).map((option) => option.label));
  const showActive = labels.size === 0 || labels.has('Active');
  const showDisabled = labels.size === 0 || labels.has('Disabled');
  return rows.filter((row) => (row.badgeNested?.enabled ? showActive : showDisabled));
}
